<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" >
      <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild> 
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div class="relative inline-block align-bottom bg-white rounded-lg px-36 py-20 text-left overflow-visible shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full sm:p-6">
            <LoadingSpinnerHub class="pb-14 pt-9 mt-5" v-if="loading" />
              <div>
                <div v-show="!loading">
                  <div class="flex justify-between pr-2 pl-1 pb-1">
                  <div class="flex pt-1 pb-2">
                    <div class="select-none">
                      <h4 class="text-lg font-bold text-gray-700">Wybierz trasy do pobrania</h4>
                      <p class="text-base mt-1 text-gray-500">W tym miejscu możesz wybrać trasy, które chcesz umieścić na pliku XLSX.</p>
                    </div>
                  </div>
                    <div class="pt-2 items-center -mr-1" >
                      <!-- <XIcon @click.prevent="emitClose(), addToCart(this.checkedVariants)" class="transition-all duration-300 w-6 h-6 text-gray-400 hover:text-gray-700" /> -->
                      <XIcon @click.prevent="emitClose()" class="transition-all duration-300 w-6 h-6 text-gray-400 hover:text-gray-700" />
                    </div>
                  </div>
                  <div v-if="this.routes.length > 0 || this.routesToPrint.length > 0" class="flex gap-6 max-h-96 border border-gray-200 rounded-md p-4 bg-gray-50">
                    <div class="flex-1 flex flex-col gap-3">
                      <div class="flex items-center justify-between">
                        <h3 class="text-sm font-semibold text-gray-700">Dostępne trasy</h3>
                        <span class="text-xs text-gray-400">Przeciągnij, aby przenieść</span>
                      </div>

                      <!-- TU: Twój pierwszy draggable (NIE zmieniam atrybutów) -->
                      <!-- ... -->
                       <draggable v-model="this.routes" class="w-full flex flex-col h-full divide-y divide-gray-200 overflow-y-auto">
                          <template v-slot:item="{ item, index }">
                            <div>
                              <li
                                class="px-4 py-3 hover:bg-gray-100 transition-all duration-300 !cursor-pointer list-group-item list-none flex items-center gap-2"
                              >
                                <div class="flex flex-col gap-1 w-full">
                                  <div class="flex gap-1 items-center justify-between">
                                    <div class="flex flex-col">
                                      <div class="text-xs text-gray-500 flex items-center flex-wrap">
                                        <div v-if="item.country !== undefined">
                                            <img v-if="item.country.flagUrl.length>0" :src="item.country.flagUrl" v-tooltip="`${item.country.displayName}`" class="h-3 w-5 mr-1 border border-gray-300">
                                            <span v-if="item.country.flagUrl.length === 0">---</span>
                                        </div>
                                        {{ moment.unix(item.date.start.seconds || item.date.start._seconds).format("LL") }} - 
                                        {{ moment.unix(item.date.end.seconds || item.date.end._seconds).format("LL") }}
                                      </div>
                                      <div class="text-xs font-semibold">
                                        {{ item.title }}
                                      </div>
                                    </div>

                                    <!-- Prawa strona: mini-status/piktogram (opcjonalnie) -->
                                    <div class="flex items-center gap-1">
                                      <span
                                        class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full bg-gray-50 text-gray-600 border border-gray-200"
                                      >
                                        {{ item.orders.length }}
                                      </span>
                                    </div>
                                  </div>

                                  <!-- „Linia czasu” jak w leadach; pokaże się tylko gdy masz takie pola -->
                                  <div v-if="item.createdAt" class="text-xs text-gray-400">
                                    {{ item.createdAt }}
                                  </div>
                                </div>
                              </li>
                            </div>
                          </template>
                      </draggable>
                    </div>

                    <div class="w-px bg-gray-200 self-stretch"></div>

                    <div class="flex-1 flex flex-col gap-3">
                      <div class="flex items-center justify-between">
                        <h3 class="text-sm font-semibold text-gray-700">Do wydruku</h3>
                        <span class="text-xs text-gray-400">Upuść tutaj, by dodać</span>
                      </div>
                      <draggable v-model="this.routesToPrint" class="w-full flex flex-col h-full divide-y divide-gray-200 overflow-y-auto">
                          <template v-slot:item="{ item, index }">
                            <div>
                              <li
                                class="px-4 py-3 hover:bg-gray-100 transition-all duration-300 !cursor-pointer list-group-item list-none flex items-center gap-2"
                              >
                                <div class="flex flex-col gap-1 w-full">
                                  <div class="flex gap-1 items-center justify-between">
                                    <div class="flex flex-col">
                                      <div class="text-xs text-gray-500 flex items-center flex-wrap">
                                        <div v-if="item.country !== undefined">
                                            <img v-if="item.country.flagUrl.length>0" :src="item.country.flagUrl" v-tooltip="`${item.country.displayName}`" class="h-3 w-5 mr-1 border border-gray-300">
                                            <span v-if="item.country.flagUrl.length === 0">---</span>
                                        </div>
                                        {{ moment.unix(item.date.start.seconds || item.date.start._seconds).format("LL") }} - 
                                        {{ moment.unix(item.date.end.seconds || item.date.end._seconds).format("LL") }}
                                      </div>
                                      <div class="text-xs font-semibold">
                                        {{ item.title }}
                                      </div>
                                    </div>

                                    <!-- Prawa strona: mini-status/piktogram (opcjonalnie) -->
                                    <div class="flex items-center gap-1">
                                      <span
                                        class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full bg-gray-50 text-gray-600 border border-gray-200"
                                      >
                                        {{ item.orders.length }}
                                      </span>
                                    </div>
                                  </div>

                                  <!-- „Linia czasu” jak w leadach; pokaże się tylko gdy masz takie pola -->
                                  <div v-if="item.createdAt" class="text-xs text-gray-400">
                                    {{ item.createdAt }}
                                  </div>
                                </div>
                              </li>
                            </div>
                          </template>
                        </draggable>
                        <!-- <EmptyState></EmptyState> -->

                    </div>
                  </div>
                  <EmptyState v-if="this.routes.length === 0 && this.routesToPrint.length === 0" />
                  <Transition name="fade">
                  <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse pr-2 pl-1 pb-1 gap-5">
                    <!-- <button @click="log(this.routesToPrint)" type="button" :disabled="this.routesToPrint.length === 0" :class="[this.routesToPrint.length === 0 ? 'pointer-events-none opacity-40' : '', 'w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base flex-1 font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:w-auto sm:text-sm transition-all duration-300 bg-indigo-600 hover:bg-indigo-500 gap-x-2']">
                      <DocumentDownloadIcon class="-ml-0.5 h-5 w-5" aria-hidden="true" />
                      Test
                    </button> -->
                    <button @click="generateXlsx()" type="button" :disabled="this.routesToPrint.length === 0" :class="[this.routesToPrint.length === 0 ? 'pointer-events-none opacity-40' : '', 'w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base flex-1 font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:w-auto sm:text-sm transition-all duration-300 bg-indigo-600 hover:bg-indigo-500 gap-x-2']">
                      <DocumentDownloadIcon class="-ml-0.5 h-5 w-5" aria-hidden="true" />
                      Pobierz plik XLSX
                    </button>
                    <button type="button" :class="['transition-all duration-300 border border-gray-300 w-full inline-flex justify-center rounded-md shadow-sm px-4 py-2 text-base flex-1 font-medium sm:w-auto sm:text-sm bg-white text-gray-700 hover:bg-gray-100 gap-x-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500']" @click="close">
                      Anuluj
                    </button>
                  </div>
                  </Transition>
                </div>
              </div>
          </div>
        </TransitionChild>

      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import axios from 'axios';
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { TrashIcon, BanIcon, ExclamationIcon, CursorClickIcon, XIcon, DocumentDownloadIcon} from '@heroicons/vue/outline';
import LoadingSpinnerHub from './LoadingSpinnerHub.vue';
import EmptyState from './EmptyState.vue';
import moment from 'moment'
import {db} from "@/firebase/gfbconf.js";
import Draggable from "vue3-draggable";
import ExcelJS from "exceljs"
import currency from 'currency.js';
import { vehicleOrPlaceholder } from '@/deletedVehicle';

export default {
  components: {
    Draggable, EmptyState, TrashIcon, DocumentDownloadIcon, BanIcon, LoadingSpinnerHub, XIcon, Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot, ExclamationIcon, CursorClickIcon
  },
  props: ['orders', 'variants'],
  data() {
    return {
      open: true,
      loading: true,
      blockButton: false,
      queryNumber: 0,
      sortType: {
          order: "asc",
          type: "date.start"
      },
      moment: moment,
      routes:[],
      routesToPrint: [],
      orders: [],
      vehicles: {},
      statuses: [],
      dbListener: null,
      query: null,
      pickedDateOfDelivery: null,
      pickedDateOfDeliveryUnix: null,
      orderStatuses: [],
    }
  },
  // computed: {
  //   sortedVariantsArray() {
  //     const variantsArray = Object.entries(this.orders.variants).map(([key, value]) => ({
  //       ...value, 
  //       id: key
  //     }));

  //     return variantsArray.sort((a, b) => {
  //       const numberPattern = /\d+$/; // Regex to match numbers at the end of the string
  //       const numberA = parseInt(a.name.match(numberPattern), 10);
  //       const numberB = parseInt(b.name.match(numberPattern), 10);
  //       return numberB - numberA;
  //     });
  //   }
  // },
  methods: {
    async generateXlsx() {
  this.$store.commit('setGlobalLoader',{
    show: true,
    head: `Trwa generowanie pliku "Plan Tras"...`,
    subheader: `Nie zamykaj tego okna.`,
  });

  const routes = Array.isArray(this.routesToPrint) ? this.routesToPrint : []

  const wb = new ExcelJS.Workbook()
  const ws = wb.addWorksheet("Trasy")

  const BORDER = {
    top: { style: "thin", color: { argb: "FF000000" } },
    left: { style: "thin", color: { argb: "FF000000" } },
    bottom: { style: "thin", color: { argb: "FF000000" } },
    right: { style: "thin", color: { argb: "FF000000" } },
  }


  const STATUS_COLORS = [
    { text: "spakowane",            font: "000000", fill: "aa9950" },
    { text: "sprawdzone",           font: "11734b", fill: "d4edbc" },
    { text: "anulacja",             font: "fcc8c2", fill: "b10202" },
    { text: "STOP produkcja",       font: "e0e0e0", fill: "3d3d3d" },
    { text: "w trakcie",            font: "753800", fill: "ffc8aa" },
    { text: "wyjechało",            font: "bfe0f6", fill: "125406" },
    { text: "zamówione",            font: "e5cff1", fill: "5a3286" },
    { text: "LOGAN",                font: "ffc8aa", fill: "753800" },
    { text: "magazyn piaski",       font: "5a3286", fill: "e6cff2" },
    { text: "brak w fabryce",       font: "0a53a8", fill: "bfe1f6" },
    { text: "przyjete na magazyn",  font: "000000", fill: "ee12a2" },
    { text: "magazyn",              font: "bcdef5", fill: "0a53a8" },
  ]

  const currencyFmt = (code) => {
    const map = {
      PLN: '#,##0.00 "PLN"',
      EUR: '#,##0.00 "EUR"',
      USD: '#,##0.00 "USD"',
      GBP: '#,##0.00 "GBP"',
    }
    return map[code] || '#,##0.00 "PLN"'
  }

  const toStr = (v) => (v == null ? "" : String(v))
  const safe = (v, fallback = "") => (v == null || v === "" ? fallback : v)

  // ——— Czarna belka (A:J) ———
  const summaryRow = ws.getRow(1)
  summaryRow.getCell(1).value = `Suma produktów Jan-Art: 0   Do wyprodukowania: 0`
  for (let c = 1; c <= 10; c++) {
    const cell = summaryRow.getCell(c)
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF000000" } }
    cell.font = { bold: true, size: 20, color: { argb: "FFFFFFFF" } }
    cell.alignment = { vertical: "middle", horizontal: "left" }
  }
  ws.mergeCells(1, 1, 1, 10)

  let r = 2 // trasy od razu pod belką
  const JANART_COL = 25 // Y

  for (const route of routes) {
    // ——— Header trasy (A:J) ———
    const routeName = route?.title != null
      ? route.title
      : `${safe(route?.vehicle?.brand, "???")} ${safe(route?.vehicle?.model, "???.")}`

    const head = ws.getRow(r)
    head.getCell(1).value = routeName
    for (let c = 1; c <= 10; c++) {
      const cell = head.getCell(c)
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF08FC04" } }
      cell.font = { bold: true, size: 15, color: { argb: "FF000000" } }
      cell.alignment = { vertical: "middle", horizontal: "left" }
    }
    ws.mergeCells(r, 1, r, 10)
    r++

    // ——— Linia info (A:J) ———
    const routeId = safe(route?.id, "???")
    const routeDesc = safe(route?.description, "--")

    let routeDrivers = "--"
    if (Array.isArray(route?.drivers) && route.drivers.length > 0) {
      routeDrivers = route.drivers.map(d => {
        const name = safe(d?.name, "???")
        const surname = safe(d?.surname, "???")
        const phone = safe(d?.contact?.phone, "???")
        return `${name} ${surname} (tel: ${phone})`
      }).join(", ")
    }

    const brand = safe(route?.vehicle?.brand, "???")
    const model = safe(route?.vehicle?.model, "???")
    const plate = safe(route?.vehicle?.attribs?.licensePlate?.value, "???")
    const routeVehicle = `${brand} ${model} (rej. ${plate})`

    const startSec = route?.date?.start?.seconds ?? route?.date?.start?._seconds
    const endSec   = route?.date?.end?.seconds   ?? route?.date?.end?._seconds
    const routeDate = (typeof moment !== "undefined" && startSec && endSec)
      ? `${moment.unix(startSec).format("LL")} - ${moment.unix(endSec).format("LL")}`
      : "--"

    const routeValue = `${toStr(this.getValues?.(route) ?? "")}, Kwota dostawy: ${toStr(this.createDeliveryPrice?.(route) ?? "")}`

    const infoRowIdx = r
    const info = ws.getRow(infoRowIdx)
    info.getCell(1).value =
      `ID trasy: ${routeId}   ` +
      `Opis trasy: ${routeDesc}   ` +
      `Kierowcy: ${routeDrivers}   ` +
      `Pojazd: ${routeVehicle}   ` +
      `Data trasy: ${routeDate}   ` +
      `Ilość Jan-Art: 0   ` +
      `Wartość trasy brutto: ${routeValue}`
    for (let c = 1; c <= 10; c++) {
      const cell = info.getCell(c)
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF08FC04" } }
      cell.font = { bold: true, size: 11, color: { argb: "FF000000" } }
      cell.alignment = { vertical: "middle", horizontal: "left", wrapText: false }
    }
    ws.mergeCells(infoRowIdx, 1, infoRowIdx, 10)
    r++

    // ——— Nagłówki tabeli ———
    ws.getRow(r).values = [
      "L.p.",
      "Adres",
      "Produkty",
      "Producenci",
      "Kwota netto",
      "Zewnętrzne ID",
      "Komentarz wewnętrzny",
      "Czas realizacji",
      "Status",
      "☑/☐",
    ]
    ws.getRow(r).font = { bold: true, color: { argb: "FF000000" } }
    ws.getRow(r).alignment = { vertical: "middle", horizontal: "center", wrapText: false }
    ws.getRow(r).eachCell((cell) => (cell.border = BORDER))
    r++

    // ——— Zamówienia ———
    const startOrderRow = r
    let routeSelfProduction = 0

    for (let o = 0; o < (route.orders?.length || 0); o++) {
      const crntOrderDoc = await route.orders[o].ref.get()
      const crntOrder = crntOrderDoc.data()

      const lp = o + 1
      const address =
        `${crntOrder.delivery?.country?.code || ""}, ` +
        `${crntOrder.delivery?.postCode || ""}, ` +
        `${crntOrder.delivery?.city || ""}, ` +
        `${crntOrder.delivery?.address || ""}`

      // 1) Status → tekst
      const statusId = Number(crntOrder.statusId)
      const isMagazyn = statusId === 3
      const isAnulacja = statusId === 404
      const statusText = isMagazyn ? "magazyn" : (isAnulacja ? "anulacja" : "")

      // 2) Produkty + czasy + Jan-Art count
      const { productsString, productionTimeMinutes, janArtCount } = await this.createProductsLine(crntOrder)
      const janArtQty = Number(janArtCount) || 0
      routeSelfProduction += janArtQty

      // 3) Pozostałe pola
      const manufacturerList = this.getManufacturer(crntOrder)
      const manufacturers = Array.isArray(manufacturerList)
        ? manufacturerList.join(" | ")
        : String(manufacturerList || "")

      const isJanArt = janArtQty > 0

      const externalOrderId =
        crntOrder.originName === 'Manual'
          ? (crntOrder.meta?.external?.ids?.externalOrderId ?? '---')
          : (crntOrder.origin?.meta?.external?.ids?.externalOrderId?.length > 0
              ? crntOrder.origin.meta.external.ids.externalOrderId
              : (crntOrder.origin?.meta?.external?.ids?.bolOrderId?.length > 0
                  ? crntOrder.origin.meta.external.ids.bolOrderId
                  : (crntOrder.origin?.meta?.external?.ids?.hoodOrderId?.length > 0
                      ? crntOrder.origin.meta.external.ids.hoodOrderId
                      : (crntOrder.origin?.meta?.external?.ids?.apiloOrderId?.length > 0
                          ? crntOrder.origin.meta.external.ids.apiloOrderId
                          : (crntOrder.origin?.meta?.external?.ids?.ottoOrderId?.length > 0
                              ? crntOrder.origin.meta.external.ids.ottoOrderId
                              : "--"))))) +
            " " +
            `(${crntOrder.origin?.meta?.external?.source?.name?.length > 0
                ? crntOrder.origin.meta.external.source.name
                : crntOrder.originName})`

      const orderNetValue = this.countOrderNetValue(crntOrder)
      const cl = this.createCommentList(crntOrder)
      const noteInsideOrder = Array.isArray(cl) ? cl.join(", ") : (cl || "")

      // 4) Wpis do Excela (A–J)
      const row = ws.getRow(r)
      row.values = [
        lp,
        address,
        productsString,        // C
        manufacturers,         // D
        orderNetValue,         // E
        externalOrderId,       // F
        noteInsideOrder,       // G
        productionTimeMinutes, // H
        statusText,            // I
        0                      // J
      ]

      row.eachCell((cell, col) => {
        cell.border = BORDER
        cell.alignment = { vertical: "top", horizontal: "left", wrapText: false }
        cell.font = { color: { argb: "FF000000" } }
        if (isJanArt && (col === 4)) {
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFC04" } } // #fffc04
        }
      })

      // 5) Kwota netto format
      const currencyCode = crntOrder?.payment?.currency || crntOrder?.currency || "PLN"
      const priceCell = ws.getCell(r, 5)
      priceCell.numFmt = currencyFmt(currencyCode)
      priceCell.alignment = { horizontal: "right", vertical: "top", wrapText: false }

      // 6) KOLUMNA Y (25): ilość Jan-Art dla wiersza (do dynamicznych sum)
      const yCell = ws.getCell(r, JANART_COL)
      yCell.value = janArtQty
      yCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF000000" } }
      yCell.font = { color: { argb: "FFFFFFFF" }, size: 10 }
      yCell.alignment = { horizontal: "center", vertical: "middle" }

      r++
    }

    const endOrderRow = r - 1

    // Zaktualizuj zieloną linię info (ilość Jan-Art dla tej trasy)
    ws.getCell(infoRowIdx, 1).value =
      `ID trasy: ${routeId}   ` +
      `Opis trasy: ${routeDesc}   ` +
      `Kierowcy: ${routeDrivers}   ` +
      `Pojazd: ${routeVehicle}   ` +
      `Data trasy: ${routeDate}   ` +
      `Ilość Jan-Art: ${routeSelfProduction}   ` +
      `Wartość trasy brutto: ${routeValue}`

    // Dropdown Status (I)
    ws.dataValidations.add(`I${startOrderRow}:I${endOrderRow}`, {
      type: "list",
      formulae: [`"${STATUS_COLORS.map(s => s.text).join(",")}"`],
      allowBlank: true,
    })

    // Pusty status → szare tło
    ws.addConditionalFormatting({
      ref: `I${startOrderRow}:I${endOrderRow}`,
      rules: [{
        type: "cellIs",
        operator: "equal",
        formulae: ['""'],
        style: {
          fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFF0ECEC" } },
          font: { color: { argb: "FF000000" } }
        }
      }]
    })

    // Kolory statusów
    STATUS_COLORS.forEach(s => {
      ws.addConditionalFormatting({
        ref: `I${startOrderRow}:I${endOrderRow}`,
        rules: [{
          type: "cellIs",
          operator: "equal",
          formulae: [`"${s.text}"`],
          style: {
            fill: { type: "pattern", pattern: "solid", fgColor: { argb: s.fill } },
            font: { color: { argb: s.font } },
          }
        }]
      })
    })

    // Checkbox (J): 0/1 -> ☐/☑
    ws.dataValidations.add(`J${startOrderRow}:J${endOrderRow}`, {
      type: "list",
      formulae: ['"0,1"'],
      allowBlank: false,
    })
    ws.getColumn(10).numFmt = '[=1]"☑";[=0]"☐"'
    ws.getColumn(10).alignment = { horizontal: "center" }

    // Odstęp 5 pustych wierszy między trasami
    r += 5
  }

  // ——— X1/X2: formuły (z Y) + czarny background ———
  const x1 = ws.getCell('X1')
  x1.value = { formula: 'SUM(Y:Y)' } // suma Jan-Art
  x1.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF000000" } }
  x1.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } }
  x1.alignment = { vertical: "middle", horizontal: "left" }



    // { text: "spakowane",            font: "000000", fill: "aa9950" }, xX
    // { text: "sprawdzone",           font: "11734b", fill: "d4edbc" }, xX
    // { text: "anulacja",             font: "fcc8c2", fill: "b10202" }, xX
    // { text: "STOP produkcja",       font: "e0e0e0", fill: "3d3d3d" }, xX
    // { text: "w trakcie",            font: "753800", fill: "ffc8aa" },
    // { text: "wyjechało",            font: "bfe0f6", fill: "125406" }, xX
    // { text: "zamówione",            font: "e5cff1", fill: "5a3286" },
    // { text: "LOGAN",                font: "ffc8aa", fill: "753800" },
    // { text: "magazyn piaski",       font: "5a3286", fill: "e6cff2" }, xX
    // { text: "brak w fabryce",       font: "0a53a8", fill: "bfe1f6" },
    // { text: "przyjete na magazyn",  font: "000000", fill: "ee12a2" }, xX
    // { text: "magazyn",              font: "bcdef5", fill: "0a53a8" }, xX
  const x2 = ws.getCell('X2')
  // Do wyprodukowania = SUM(Y:Y) - (magazyn + magazyn piaski)
  x2.value = { formula: 'SUM(Y:Y)-(SUMIF(I:I;"magazyn";Y:Y)+SUMIF(I:I;"magazyn piaski";Y:Y)+SUMIF(I:I;"anulacja";Y:Y)+SUMIF(I:I;"spakowane";Y:Y)+SUMIF(I:I;"STOP produkcja";Y:Y)+SUMIF(I:I;"sprawdzone";Y:Y)+SUMIF(I:I;"wyjechało";Y:Y)+SUMIF(I:I;"przyjete na magazyn";Y:Y))' }
  x2.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF000000" } }
  x2.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } }
  x2.alignment = { vertical: "middle", horizontal: "left" }

  ws.getCell('A1').value = { formula: 'CONCATENATE("Suma produktów Jan-Art: ",X1," Do wyprodukowania: ",X2)' }

  // ——— Stylizacja całej kolumny Y (czarna) ———
  const lastUsedRow = ws.lastRow?.number || r
  ws.getColumn(JANART_COL).width = 6
  for (let rowIdx = 1; rowIdx <= lastUsedRow; rowIdx++) {
    const c = ws.getCell(rowIdx, JANART_COL)
    c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF000000" } }
    c.font = { color: { argb: "FFFFFFFF" }, size: 10 }
    c.alignment = { horizontal: "center", vertical: "middle" }
  }

  // ——— Szerokości widocznych kolumn (C=80, G=50) ———
  ws.columns = [
    { width: 6 },   // A
    { width: 40 },  // B
    { width: 80 },  // C
    { width: 25 },  // D
    { width: 15 },  // E
    { width: 20 },  // F
    { width: 50 },  // G
    { width: 20 },  // H
    { width: 18 },  // I
    { width: 10 },  // J
    // K–W bez zmian
    // Y (25) ustawione wyżej
  ]

  // ——— Zapis ———
  const buffer = await wb.xlsx.writeBuffer()
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  })
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  let currentTimeAndDate = moment().format("DD/MM/YYYY_HH:mm:ss")
  a.download = `Plan_tras_${currentTimeAndDate}.xlsx`
  a.click()
  URL.revokeObjectURL(url)

  this.$store.commit("resetGlobalLoader");
  this.$store.commit('setNotification',{
    show: true,
    head: `Wygenerowano plik "Plan_tras_${currentTimeAndDate}.xlsx"...`,
    subheader: `Plik został pobrany na Twój komputer.`,
    success: true
  });
},
async createProductsLine(order) {
  const iterablePositions = Array.isArray(order?.positions)
    ? order.positions
    : (order?.positions && typeof order.positions === "object")
      ? Object.values(order.positions)
      : []

  const productMap = new Map()
  const times = []
  let janArtCount = 0
  const JAN_ART_NAME = "Jan-Art Sp. z o.o."

  for (const crntPos of iterablePositions) {
    const qty = crntPos?.product?.quantity ?? crntPos?.quantity ?? 1
    const variantId = crntPos?.product?.variantId
    let productData

    try {
      if (crntPos?.product?.ref?.get) {
        const snap = await crntPos.product.ref.get()
        productData = snap?.data?.()
      }
    } catch (e) {
      productData = undefined
    }

    // --- klucz oparty WYŁĄCZNIE o nazwę wariantu ---
    let variantName = ""
    if (productData?.variants?.[variantId]) {
      variantName = productData.variants[variantId].name
    } else if (variantId != null) {
      variantName = "(USUNIĘTY WARIANT)"
    } else {
      variantName = crntPos?.product?.name ?? "Produkt"
    }

    // Zliczamy ilość dla danego wariantu
    productMap.set(variantName, (productMap.get(variantName) || 0) + qty)

    // czas produkcji
    const prodTime = productData?.productionTimeMinutes ?? crntPos?.product?.productionTimeMinutes
    if (prodTime !== undefined) {
      times.push(`${prodTime} min`)
    }

    // producent
    const man = productData?.manufacturer ?? crntPos?.product?.manufacturer
    const manName = typeof man === "object" ? man?.name : man
    if (manName === JAN_ART_NAME) {
      janArtCount += qty
    }
  }

  // Budujemy końcowy string — tylko variantName
  const productsString = Array.from(productMap.entries())
    .map(([variant, qty]) => `${qty}x ${variant}`)
    .join(" ")

  const productionTimeMinutes = times.length ? times.join(", ") : "-"

  return { productsString, productionTimeMinutes, janArtCount }
},
    getManufacturer(order) {
  const manufacturers = new Set()

  for (const [, position] of Object.entries(order.positions || {})) {
    const man = position?.product?.manufacturer
    const manName = typeof man === "object" ? man?.name : man

    if (manName) {
      manufacturers.add(manName)
    }
  }

  return Array.from(manufacturers)
},
    countOrderNetValue(order) {
      let value = {
        totalOrderValue: 0,
        currency: '',
      }

      for (const pos in order.positions) {
        const crntPos = order.positions[pos]
        const qty = Number(crntPos?.product?.quantity) || 0
        const gross = Number(crntPos?.product?.pricePerItemTaxIncluded) || 0
        const taxRate = Number(crntPos?.product?.taxRate) || 0

        // Netto = brutto / (1 + stawkaVAT)
        const net = gross / (1 + taxRate / 100)
        // console.log('brutto: ' +gross + ' | stawka VAT: ' + taxRate + ' | netto: ' + net);

        value.totalOrderValue += qty * net
        if (!value.currency) {
          value.currency = crntPos?.product?.currency || ""
        }
      }

      return `${value.totalOrderValue.toFixed(2)} ${value.currency}`
    },
    createCommentList(order)
    {
        const products = Object.entries(order.positions)
        let translatedListOfComments = [];
        products.forEach(element => {
            if(element[0])
            {
                translatedListOfComments.push(element[1].infos.onOrderCreation);
            }
        })

        return translatedListOfComments
    },
    createDeliveryPrice(route)
        {
          let translatedListOfDelivery = [];
            if(route.value !== undefined)
            {
                if(route.value.delivery !== undefined)
                {
                    if(Object.keys(route.value.delivery).length > 0)
                    {
                        const values = Object.entries(route.value.delivery)
                        values.forEach(element => {
                            if(element[0])
                            {
                                translatedListOfDelivery.push(parseFloat(element[1].price).toFixed(2) + ' ' + element[0]);
                            }
                        })
                    }
                    else
                    {
                       translatedListOfDelivery.push('---'); 
                    }
                }
                else
                {
                    translatedListOfDelivery.push('---');
                }
            }
            else
            {
                translatedListOfDelivery.push('---');
            }
            return translatedListOfDelivery
        },
    getValues(route)
        {
            let translatedListOfValues = [];
            if(route.value !== undefined && route.value !== null)
            {
                if(route.value.total !== undefined && route.value.total !== null)
                {
                    const values = Object.entries(route.value.total)
                    values.forEach(element => {
                        if(values.length > 1)
                        {
                            if(element[0])
                            {
                                if(element[1].value > 0)
                                {
                                    let parsedValue = currency(element[1].value).value
                                    translatedListOfValues.push(`${parsedValue + ' ' + element[0]}`);
                                }
                            }
                        }
                        else
                        {
                            if(element[0])
                            {
                                if(element[1].value > 0)
                                {
                                    let parsedValue = currency(element[1].value).value
                                    translatedListOfValues.push(`${parsedValue + ' ' + element[0]}`);
                                }
                                else
                                {
                                    translatedListOfValues.push('---');
                                }
                            }
                        }
                    })
                }
                else
                {
                    translatedListOfValues.push('---');
                }
            }
            else
            {
                translatedListOfValues.push('---');
            }
            return translatedListOfValues
        },
    log(log){
      console.log(log);
    },
    async getVehicles(){
      let vehicleData = await db.collection('Vehicles').get()
      for (let i = 0; i < vehicleData.docs.length; i++) {
          const vehicle = vehicleData.docs[i];
          const vehicleToPush = vehicle.data()
          this.vehicles[vehicleToPush.id] = vehicleToPush
      }
    },
    async getStatuses()
    {
        try {
            let res = await db.collection("RouteStatuses").doc("StatusList").get()
            this.statuses = res.data().list
        } catch (error)
        {
            console.log(error);    
        }
    },
    async getOrderStatuses()
    {
        try {
            const statuses = await db.collection("OrderStatuses").get()
            statuses.forEach(statusesList => {
                this.orderStatuses = statusesList.data().list
            })
        } catch (error)
        {
            console.log(error);   
        }
    },
    async getRoutes()
    {
        this.query = null;
        if(this.dbListener !== null){
            this.dbListener()
            this.dbListener = null
        }
        this.query = db.collection("Routes").where("statusId", "in", [1,2])

        if(this.pickedDateOfDeliveryUnix !== null){
            this.pickedDateOfDeliveryUnix = parseInt(this.pickedDateOfDeliveryUnix)
            let startOfDayDelivery = this.pickedDateOfDeliveryUnix
            this.query = this.query.where('date.start', "==", moment.unix(startOfDayDelivery).toDate())
        }

        this.query = this.query.orderBy(`${this.sortType.type}`, `${this.sortType.order}`)

        const getOrdersQueryNumber = await this.query.get()
        if(!getOrdersQueryNumber.empty)
        {
            this.queryNumber = getOrdersQueryNumber.docs.length;
        }

        this.dbListener = this.query
        .onSnapshot((querySnapshot) => {
            this.routes = [];
            for (let i = 0; i < querySnapshot.docs.length; i++) {
                const data = querySnapshot.docs[i].data()
                data.vehicle = vehicleOrPlaceholder(this.vehicles, data.vehicle?.id)
                this.routes.push(data)
            }
            this.loading = false;
        });
    },
    emitClose()
    {
      this.$emit("close");
    },
    close()
    {
      this.emitClose();
      this.open = false
    }
  },
  async created() {
    if(!this.$store.state.userData.permissions.admin && !this.$store.state.userData.permissions.routes)
        {
            this.$router.push("/hub")
        }
        else
        {
            await this.getVehicles()
            await this.getStatuses()
            await this.getOrderStatuses();
            await this.getRoutes();
        }
  },
  beforeUnmount() {
      if(this.dbListener !== null){
          this.dbListener();
      }
  },
}
</script>

<style scoped>
/* width */
::-webkit-scrollbar {
    width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
    background: rgba(209, 213, 219);
    border-radius: 5px;
}
  
/* Handle */
::-webkit-scrollbar-thumb {
    background: rgba(107, 114, 128);
    border-radius: 5px;
}
  
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
} 
</style>